import MobileDetect from 'mobile-detect';
import Bowser from 'bowser';

export const md = new MobileDetect(navigator.userAgent);

export const DEVICE_OS = {
  IOS: 'ios',
  ANDROID: 'android',
  OTHER: 'other',
};

export const DEVICE_TYPE = {
  IN_APP_WEBVIEW: 'in-app-webview',
  BROWSER: 'browser',
};

export const deviceOS = () => {
  switch (md.os()) {
    case 'iOS':
      return DEVICE_OS.IOS;
    case 'AndroidOS':
      return DEVICE_OS.ANDROID;
    default:
      return DEVICE_OS.OTHER;
  }
};

export const deviceType = () => {
  const useragent = navigator.userAgent;
  const rules = [
    'WebView',
    '(iPhone|iPod|iPad)(?!.*Safari/)',
    'Android.*(wv|.0.0.0)',
    'Autopass/(.*)',
    'MyRewards/(.*)',
  ];
  const regex = new RegExp(`(${rules.join('|')})`, 'ig');
  const isMatch = Boolean(useragent.match(regex));
  if (isMatch) {
    return DEVICE_TYPE.IN_APP_WEBVIEW;
  } else {
    return DEVICE_TYPE.BROWSER;
  }
};

export const getBrowser = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  return browser.getBrowserName();
};
